export type SessionUser = {
  id?: string;
  email?: string;
  name?: string;
  role?: string;
  status?: string;
};

let sessionPromise: Promise<SessionUser | null> | null = null;

export function getSession(): Promise<SessionUser | null> {
  if (!sessionPromise) {
    sessionPromise = fetch("/api/session", { cache: "no-store", credentials: "same-origin" })
      .then(async (res) => {
        if (!res.ok) return null;
        const body = await res.json();
        return body.user ?? null;
      })
      .catch(() => null);
  }
  return sessionPromise;
}

export function resetSessionCache() {
  sessionPromise = null;
}

export async function logout() {
  await fetch("/api/session/logout", { method: "POST", credentials: "same-origin" }).catch(() => {});
  resetSessionCache();
}
